<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table scrollable">

    <div #header
         class="layout-row layout-align-start-center tr text-uppercase fade-element-in-only">

      <div class="th flex xxxsmall text-ellipsis"></div>

      <div *ngIf="enabledColumnsMap.agentName?.enabled"
           class="th flex large text-ellipsis"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.agentName.name | translate" openDelay="300"
           triggers="hover">
        {{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.agentName.name | translate}}
      </div>

      <div *ngIf="enabledColumnsMap.agentStatus?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.agentStatus.name | translate" openDelay="300"
           triggers="hover"
           class="th flex xsmall text-ellipsis">{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.agentStatus.name | translate}}</div>

      <div *ngIf="enabledColumnsMap.tags?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.tags.name | translate" openDelay="300"
           triggers="hover"
           class="th flex medium text-ellipsis">{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.tags.name | translate}}</div>

      <div *ngIf="enabledColumnsMap.totalDropoffs?.enabled || enabledColumnsMap.completedDropoffs?.enabled"
           class="th flex xxsmall text-ellipsis" translate>Tasks
      </div>

      <div *ngIf="enabledColumnsMap.completedTasksEstimationFromGeoEvents?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.completedTasksEstimationFromGeoEvents.name | translate"
           openDelay="300" triggers="hover"
           class="th flex small text-ellipsis"
           translate>{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.completedTasksEstimationFromGeoEvents.name}}
      </div>

      <div *ngIf="enabledColumnsMap.numberOfLateDropoffs?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.numberOfLateDropoffs.name | translate"
           openDelay="300" triggers="hover"
           class="th flex xsmall text-ellipsis"
           translate>{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.numberOfLateDropoffs.name}}</div>

      <div *ngIf="enabledColumnsMap.currentTaskStatus?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.currentTaskStatus.name | translate" openDelay="300"
           triggers="hover"
           class="th flex large text-ellipsis">{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.currentTaskStatus.name | translate}}</div>

      <div *ngIf="enabledColumnsMap.currentTaskIdFromGeoEvents?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.currentTaskIdFromGeoEvents.name | translate"
           openDelay="300" triggers="hover"
           class="th flex large text-ellipsis"
           translate>{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.currentTaskIdFromGeoEvents.name}}</div>

      <div *ngIf="enabledColumnsMap.currentTaskStartTimeEstimation?.enabled"
           [ngbTooltip]="'The left value is the geo-event estimation, while the planned value is on the right' | translate"
           openDelay="300" triggers="hover"
           class="th flex large text-ellipsis"
           translate>{{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.currentTaskStartTimeEstimation.name}}</div>

      <div *ngIf="enabledColumnsMap.taskPackageList?.enabled"
           [ngbTooltip]="'WIDGET_TABLE_COLUMNS.' + enabledColumnsMap.taskPackageList.name | translate" openDelay="300"
           triggers="hover"
           class="th flex small text-ellipsis" translate>
        {{'WIDGET_TABLE_COLUMNS_SHORT.' + enabledColumnsMap.taskPackageList.name | translate}}
      </div>


    </div>

    <div class="full-height flex rows-container layout-column">
      <cdk-virtual-scroll-viewport [itemSize]="50" class="flex viewport" (scroll)="getNextBatch()">
        <app-agent-progress-table-row class="item"
                                      *cdkVirtualFor="let agentProgress of data"
                                      [agentProgress]="agentProgress"
                                      [enabledColumnsMap]="enabledColumnsMap"
                                      (askToEnableGpsEvent)="onSendNotificationToAgents($event.agentPnType, $event.agentId)"
                                      (askToClockIn)="onSendNotificationToAgents($event.agentPnType, $event.agentId)"
                                      (askToEnableGpsPermissionsEvent)="onSendNotificationToAgents($event.agentPnType, $event.agentId)"
                                      (swapServicesEvent)="onSwapServices($event)"
                                      (viewAgentItineraryEvent)="onViewAgentItinerary(agentProgress.agentId)"
                                      (viewTasksEvent)="onViewAgentTasks($event.agent, $event.tasks)">

        </app-agent-progress-table-row>
      </cdk-virtual-scroll-viewport>
    </div>

  </div>
</div>


